import { createContext } from "react";

const WalletAccountsContext = createContext(null);

export default WalletAccountsContext;
